import {  MenuProps } from "antd";
import { Cable, Check, ClipboardType, FileText, ListChecks, ListTodo, Image, Images } from "lucide-react";
import { ExamQuestionType } from "@types";
import { Translation } from "react-i18next";

export const newBankPoolItems = (isPeformaExam?: boolean): MenuProps['items'] => [
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.singleChoice")
      }
      </Translation>,
      key: ExamQuestionType.SingleChoice,
      icon: <ListTodo />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.multipleChoices")
      }
      </Translation>,
      key: ExamQuestionType.MultipleChoices,
      icon: <ListChecks />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.shortAnswer")
      }
      </Translation>,
      key: ExamQuestionType.ShortAnswer,
      disabled: isPeformaExam,
      icon: <ClipboardType />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.correctIncorrect")
      }
      </Translation>,
      key: ExamQuestionType.CorrectIncorrect,
      icon: <Check />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.essay")
      }
      </Translation>,
      key: ExamQuestionType.EssayQuestion,
      disabled: isPeformaExam,
      icon: <FileText />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.connecting")
      }
      </Translation>,
      key: ExamQuestionType.Connecting,
      icon: <Cable />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.imageChoice")
      }
      </Translation>,
      key: ExamQuestionType.ImageChoice,
      icon: <Image />,
    },
    {
      label: <Translation> 
      {
          t => t("pages.bankPool.multipleImageChoice")
      }
      </Translation>,
      key: ExamQuestionType.ImageMultipleChoice,
      icon: <Images />,
    }
  ];